import { render } from "./facilities-modal.vue?vue&type=template&id=a07dd882"
import script from "./facilities-modal.vue?vue&type=script&lang=js"
export * from "./facilities-modal.vue?vue&type=script&lang=js"

import "./facilities-modal.vue?vue&type=style&index=0&id=a07dd882&lang=css"

import exportComponent from "/home/gerind/Desktop/work/gobe-system/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__